import { useTranslation } from "next-i18next";

import ProductCard from "../product/ProductCard";

import { useRouter } from "next/router";
import useSearchProducts from "@whoppah/apollo/hooks/useSearchProducts";
import { useCallback } from "react";
import { analyticsService } from "@/common/services/analytics/analytics.service";

const BlogProducts = ({ search }) => {
  const { t } = useTranslation();
  const router = useRouter();
  const { data, loading } = useSearchProducts({
    variables: {
      ...search,
      pageSize: 4,
      lang: router.locale.toUpperCase(),
    },
  });

  const products = data?.searchProducts?.items;
  const searchMeta = {
    queryId: data?.searchProducts?.queryID ?? undefined,
    indexName: data?.searchProducts?.indexName ?? undefined,
    page: data?.searchProducts?.pagination?.page,
    limit: data?.searchProducts?.pagination?.limit,
  };

  /** Track `view_item_list` event. */
  analyticsService.useExecAfterMount(
    useCallback(() => {
      if (!loading) {
        analyticsService.trackViewItemList(
          "blog_products",
          "blog_products",
          products
        );
      }
    }, [products, loading])
  );

  if (products?.length === 0 || loading) {
    return null;
  }

  return (
    <section>
      <h3 className="mb-[24px] font-poppins text-[24px] font-semibold md:text-[30px]">
        {t("blog:blog-shop-items")}
      </h3>
      <div className="grid grid-cols-2 gap-[24px] md:grid-cols-4">
        {products?.map((product, index) => (
          <ProductCard
            key={product.id}
            item={product}
            searchMeta={searchMeta}
            listName="blog-products-list"
            index={index}
          />
        ))}
      </div>
    </section>
  );
};

export default BlogProducts;
